/**
 * # EPUBStructuralSematicsVocabulary
 *
 * ## RESPONSIBILITIES
 *
 *
 * ## RELATED TYPES
 *
 **/
export enum EPUBStructuralSematicsVocabulary {
    COMICS_BALLOON = 'balloon',
    COMICS_PANEL = 'panel',
    COMICS_PANEL_GROUP = 'panel-group',
    COMICS_SOUND_AREA = 'sound-area',
    COMICS_TEXT_AREA = 'text-area',

}
